import React, { useEffect, useState } from "react";
import { set, useForm } from "react-hook-form";
import { Badge, Form, Label } from "reactstrap";
import Head from "../../../layout/head/Head";
import Content from "../../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PreviewAltCard,
  Row,
} from "../../../components/Component";
import Required from "../../../myComponents/validate/Required";
import Select from "react-select";
import Status from "../../../myComponents/form/Status";
import MyDataTable from "../../../myComponents/DataTable/MyDataTable";
import MyButton from "../../../myComponents/form/MyButton";
import {
  createNodalCenterAPI,
  getDistrictListAPI,
  getNodalCenterListAPI,
  updateNodalCenterAPI,
} from "../../../api/LMS/master";
import { toast } from "react-toastify";
import ConfirmModal from "../../../myComponents/modals/ConfirmModal";
import { decrypt, encrypt } from "../../../utils/Encrypt";
import useLogout from "../../../hooks/useLogout";
import { useLocation, useNavigate } from "react-router";
import { hasPermission } from "../../../utils/myFunctions";
import ApiPaginationDataTable from "../../../myComponents/DataTable/ApiPaginationDataTable";
import ImageUpload from "../../../myComponents/form/ImageUpload";
import { ValidateImg } from "../../../utils/Utils";
import { BASE_URL_IMG_LMS } from "../../../assets/constants/constants";
import ViewImage from "../../../myComponents/modals/ViewImage";

const NodalCenter = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [mode, setMode] = useState("Add");
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const enc = JSON.parse(localStorage.getItem("userDetail"));
  const user = decrypt(enc?.data || []);
  const isView = hasPermission(user, location?.pathname, "isView");
  const isUpdate = hasPermission(user, location?.pathname, "isUpdate");
  const isDelete = hasPermission(user, location?.pathname, "isDelete");
  const isCreate = hasPermission(user, location?.pathname, "isCreate");
  const logout = useLogout();
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    setError,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      status: null,
      loading: false,
      server_search: "",
      sign_url: null,
      sign: null,
      p_sign_url: null,
      p_sign: null,
    },
  });
  //pagination
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(20);
  // pagination
  const handlePerRowsChange = (newPerPage, page) => {
    const rows = isNaN(newPerPage) ? totalRows : newPerPage;
    setPerPage(rows);
    setValue("page", page);
  };
  const handlePageChange = (page) => {
    setValue("page", page);
    const payload = {
      limit: perPage,
      page: watch("page") || 1,
      search:watch("server_search")||""
    };
     handleSearch(payload);
  };
  const [data, setData] = useState([]);
  const loading = watch("loading");
  const [districtList, setDistrictList] = useState([]);
  const [column, setColumn] = useState([
    {
      name: "Division",
      selector: (row) => row?.division,
      sortable: true,
      wrap:true
    },
    {
      name: "District",
      selector: (row) => row?.district_name,
      sortable: true,
    },
    {
      name: "Nodal Code",
      selector: (row) => row?.udise_code,
      sortable: true,
    },
    {
      name: "Nodal Name",
      selector: (row) => row?.centre_name,
      sortable: true,
      wrap: true,
    },
    {
      name: "Contact",
      selector: (row) => row?.contact_number,
      sortable: true,
      wrap:true
    },
    {
      name: "Signature",
      selector: (row) => (
        <div onClick={() => handleImageOpenPreview(`${BASE_URL_IMG_LMS}` + row?.sign_image)}>
          <img style={{ width: "50px" }} src={`${BASE_URL_IMG_LMS}` + row.sign_image} />
        </div>
      ),
      sortable: true,
    },
    {
      name: "Principal Signature",
      selector: (row) => (
        <div onClick={() => handleImageOpenPreview(`${BASE_URL_IMG_LMS}` + row?.p_sign_image)}>
          <img style={{ width: "50px" }} src={`${BASE_URL_IMG_LMS}` + row.p_sign_image} />
        </div>
      ),
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => (
        <div style={{ cursor: "pointer" }} onClick={() => handleToggleStatus(row)}>
          <Badge color={`${row.status == "Active" ? "success" : "danger"}`}>
            {row.status == "Active" ? "Active" : "Inactive"}
          </Badge>
        </div>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: "Action",
      wrap: true,
      cell: (row) => (
        <div>
          {isUpdate && (
            <Button outline color={`warning`} size={`xs`} className={`me-1`} onClick={() => handleEdit(row)}>
              {" "}
              <Icon name="edit" />
            </Button>
          )}
        </div>
      ),
    },
  ]);
  useEffect(() => {
    getDistrictList();
  }, []);

  const getDistrictList = () => {
    const data = {};
    getDistrictListAPI(data)
      .then((res) => {
        // decrypt data
        const status = res.data.status;
        // const status = decrypt(res.data.status);
        if (status === true) {
          // const decryptedResponse = decrypt(res.data.data.tableData);

          setDistrictList(res.data.data);
          toast.clearWaitingQueue();
        } else if (status === false) {
          toast.warning(res.data.message);
          toast.clearWaitingQueue();
          setDistrictList([]);
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const getNodalList = () => {
    setValue("loading", true);
    const data = {};
    getNodalCenterListAPI(data)
      .then((res) => {
        // decrypt data
        const status = res.data.status;
        // const status = decrypt(res.data.status);
        if (status === true) {
          // const decryptedResponse = decrypt(res.data.data.tableData);
          setValue("loading", false);
          setData(res.data.data?.data);
          toast.clearWaitingQueue();
        } else if (status === false) {
          setValue("loading", false);
          toast.warning(res.data.message);
          toast.clearWaitingQueue();
          setData([]);
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const handleToggleStatus = (row) => {
    setSelectedRow(row);
    setShowModal(true);
  };
  const handleDistrictChange = (sel) => {
    setValue("district", sel || "");
    trigger("district");
  };
  const handleEdit = (row) => {
    window.scrollTo(0, 0);
    setIsOpen(!isOpen);
    setMode("Edit");
    setValue("id", row.id); // Add this for consistent `formData` structure
    setValue("nodal_center", row.centre_name);
    setValue("nodal_code", row.udise_code);
    setValue("mobile_no", row.contact_number);
    setValue("sign_url", `${BASE_URL_IMG_LMS}` + row?.sign_image);
    setValue("p_sign_url", `${BASE_URL_IMG_LMS}` + row?.p_sign_image);

    setValue("status", {
      label: row.status == "Active" ? "Active" : "Inactive",
      value: row.status,
    });
    setValue("district", {
      label: row.district_name,
      value: row.district_id,
    });
  };
  const onFormSubmit = (data) => {
    const formData = new FormData();
    const body = {
      district_id: watch("district")?.value,
      district_name: watch("district")?.label,
      nodal_center: watch("nodal_center"),
      nodal_code: watch("nodal_code"),
      mobile: watch("mobile_no"),
      status:
        watch("status")?.value == "active" || watch("status")?.value == "Active"
          ? "Active"
          : watch("status")?.value == "Inactive"
          ? "Inactive"
          : "Inactive",
      ...(mode == "Edit" && { id: watch("id") }),
    }; 
    formData.append("district_id", body.district_id);
    formData.append("district_name", body.district_name);
    formData.append("nodal_center", body.nodal_center);
    formData.append("nodal_code", body.nodal_code);
    formData.append("mobile", body.mobile);
    formData.append("status", body.status); 
    if (mode == "Edit") {
      formData.append("id", body.id);
    }
    if (data?.sign!==null && typeof data?.sign !== "string") { 
      formData.append("sign_image", data?.sign);
    } else { 
      
      formData.append("sign_image", data?.sign ||"");
    }
    if (data?.p_sign!==null && typeof data?.p_sign !== "string") { 
      formData.append("p_sign_image", data?.p_sign);
    } else { 
      
      formData.append("p_sign_image", data?.p_sign ||"");
    }
    // return
    if (mode == "Add") {
      createNodalCenterAPI(formData)
        .then((res) => {
          // const status = decrypt(res.data.status);
          const status = res.data.status;
          if (status === true) {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            getNodalList();
            setIsOpen(false);
            setIsLoading(false);
          } else if (status === false) {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (status === "expired") {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          console.log("cat", err);

          setIsLoading(false);
          toast.error(err.message);
        });
    }
    if (mode == "Edit") {
      updateNodalCenterAPI(formData)
        .then((res) => {
          // const status = decrypt(res.data.status);
          const status = res.data.status;
          if (status === true) {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            getNodalList();
            setIsOpen(false);
            setIsLoading(false);
          } else if (status === false) {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (status === "expired") {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setIsLoading(false);
          toast.error(err.message);
        });
    }
  };
  const confirmStatusChange = () => {
    const updatedStatus = selectedRow.status === "Active" ? "Inactive" : "Active";
    const formObject = {
      id: selectedRow.id,
      status: updatedStatus,
    };
    const encryptedData = encrypt(formObject);
    const encryptData = {
      zero: encryptedData,
    };
    updateNodalCenterAPI(formObject)
      .then((res) => {
        // decrypt data
        const status = res.data.status;
        // const status = decrypt(res.data.status);
        if (status === true) {
          getNodalList();
          setShowModal(false);
          toast.success(res.data.message);
          toast.clearWaitingQueue();
        } else if (status === false) {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => console.error("Error updating status:", err));
  };
  const [timer, setTimer] = useState(5); // 5 seconds countdown
  useEffect(() => {
    if (!isView) {
      const interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
      // redirect to home page when the timer reaches 0
      if (timer === 0) {
        navigate(-1);
      }
      // clean up the interval when the component unmounts
      return () => clearInterval(interval);
    } else {
      setIsLoading(false);
    }
  }, [timer]);
  useEffect(() => {
    if (watch("server_search")?.length == 0) {
      handleSearch(perPage);
    }
  }, [watch("page"), perPage, watch("server_search")]);
  const handleSearch = (data) => { 
    const payload = {
      limit: perPage,
      page: watch("page") || 1,
      search:watch("server_search")||""
    };
    setIsLoading(true);
    getNodalCenterListAPI(payload)
      .then((res) => {
        const status = res.data.status;
        if (status === true) {
          console.log("res", res.data.data);
          setTotalRows(res.data.data.totalRecords);
          setData(res.data.data.data);
          setIsLoading(false);
        } else if (status === false) {
          setData([]);
          setIsLoading(false);
        } else if (status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("Err", err);
      });
  };
  const serverSideSearch = (data) => {
    const body = {
      search: data,
    };
    // return;
    getNodalCenterListAPI(body)
      .then((res) => {
        const status = res.data.status;
        if (status===true) {
          setIsLoading(false);
           setTotalRows(res.data.data.totalRecords);
          setData(res.data.data.data);
        } else if (status === false) {
          setIsLoading(false);
          setData([]);
        } else if (status === "expired") {
          setIsLoading(false);
          logout();
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("catch error", err);
      });
  };

  // Modal Image Preview
  const [imageOpen, setImageOpen] = useState(false);
  const handleImageChange = (e, errorInput, url) => {
    const file = e.target.files[0];
    if (file) {
      ValidateImg(file, (isValid) => {
        if (isValid) {
          // Process the valid image
          const imageUrl = URL.createObjectURL(file); // Create blob URL
          setValue(url, imageUrl); // Set image URL to state
          setValue(errorInput, file);
          trigger(errorInput);
          // Clear previous errors (ensure it happens after state updates)
          setTimeout(() => {
            clearErrors(errorInput);
          }, 100);
        } else {
          // Handle the invalid file type
          setError(errorInput, {
            type: "manual",
            message: "Invalid file type. Only PNG, JPEG, and JPG files are allowed.",
          });
          console.error("Invalid file type. Only PNG, JPEG, and JPG files are allowed.");
          e.target.value = ""; // Clear the input
        }
      });
    } else {
      setValue(errorInput, "");
    }
  };
  const handleImageClose = () => {
    setImageOpen(!imageOpen);
  };
  const handleImageOpenPreview = (row) => {
    setImageOpen(!imageOpen);
    setValue("image_preview", row);
    trigger("image_preview");
  };
  return (
    <>
      <Head title={"Nodal Center | Master"} />
      <Content>
        {!isView ? (
          <div className="p-5" style={{}}>
            <p style={{ color: "crimson", textAlign: "center" }}>{"Unauthorized"}</p>
            <p style={{ textAlign: "center" }}>
              You will be redirected to the home page in <b style={{ color: "crimson" }}>{timer} </b> seconds.
            </p>
          </div>
        ) : (
          <>
            <BlockHead size={`sm`}>
              <BlockBetween>
                <BlockHeadContent>
                  <BlockTitle page tag="h3">
                    {"Nodal Center"}
                  </BlockTitle>
                </BlockHeadContent>
                {isCreate && (
                  <BlockHeadContent>
                    <div className="">
                      <Button
                        color="primary"
                        outline
                        className={`  me-n1`}
                        onClick={() => {
                          setIsOpen(!isOpen);
                          setMode("Add");
                          reset();
                        }}
                      >
                        {<Icon name={isOpen ? "minus" : "plus"} />}
                      </Button>
                    </div>
                  </BlockHeadContent>
                )}
              </BlockBetween>
            </BlockHead>
            <Block>
              <Row className={`g-gs`}>
                {isOpen && (
                  <PreviewAltCard>
                    <Form onSubmit={handleSubmit(onFormSubmit)}>
                      <Row className={`g-gs`}>
                        {/* District */}
                        {user?.role == "District" ? null : (
                          <Col md={`2`}>
                            <div className="form-group">
                              <Label className="from-label" htmlFor="district">
                                District
                                <Required />
                              </Label>
                              <div className="form-control-wrap">
                                <Select
                                  className=""
                                  id="district"
                                  options={districtList}
                                  {...register("district", {
                                    required: "Please select district",
                                  })}
                                  onChange={handleDistrictChange}
                                  value={watch("district")}
                                />
                                {errors.district && <span className="invalid">{errors?.district?.message}</span>}
                              </div>
                            </div>
                          </Col>
                        )}
                        {/*Nodal Center */}
                        <Col md="4" sm="3" xxl="4">
                          <div className="form-group">
                            <Label className="form-label" htmlFor="nodal_center">
                              {"Nodal Center"}
                              <Required />
                            </Label>
                            <div className="form-control-wrap">
                              <input
                                placeholder={"Enter nodal center name"}
                                type="text"
                                id="nodal_center"
                                {...register("nodal_center", {
                                  required: {
                                    value: true,
                                    message: "Nodal center name is required",
                                  },
                                  pattern: {
                                    value:/^[\u0900-\u097F\u0041-\u005A\u0061-\u007A\s,.-]+$/,
                                    message: "Only alphabets are allowed",
                                  },
                                  minLength: {
                                    value: 3,
                                    message: "nodal center name must be at least 2 characters long",
                                  },
                                  maxLength: {
                                    value: 50,
                                    message: "Nodal center name cannot exceed 50 characters",
                                  },
                                })}
                                className="form-control"
                                value={watch("nodal_center")}
                                onChange={(e) => {
                                  setValue("nodal_center", e.target.value);
                                  trigger("nodal_center"); // Trigger validation
                                }}
                              />
                              {errors.nodal_center && <span className="invalid">{errors?.nodal_center?.message}</span>}
                            </div>
                          </div>
                        </Col>{" "}
                        {/*Nodal Code */}
                        <Col md="4" sm="3" xxl="2">
                          <div className="form-group">
                            <Label className="form-label" htmlFor="nodal_code">
                              {"Nodal Code"}
                              <Required />
                            </Label>
                            <div className="form-control-wrap">
                              <input
                                placeholder={"Enter nodal code name"}
                                type="text"
                                id="nodal_code"
                                {...register("nodal_code", {
                                  required: {
                                    value: true,
                                    message: "Nodal code is required",
                                  },
                                  minLength: {
                                    value: 3,
                                    message: "Nodal code must be at least 2 characters long",
                                  },
                                  maxLength: {
                                    value: 50,
                                    message: "Nodal code cannot exceed 50 characters",
                                  },
                                })}
                                className="form-control"
                                value={watch("nodal_code")}
                                // onChange={(e) => {
                                //   setValue("nodal_code", e.target.value);
                                //   trigger("nodal_code"); // Trigger validation
                                // }}
                                 onChange={(e) => {
                                e.target.value = e.target.value.replace(/[^0-9]/g, "");
                                setValue("nodal_code", e.target.value);
                                trigger("nodal_code");
                              }}
                              />
                              {errors.nodal_code && <span className="invalid">{errors?.nodal_code?.message}</span>}
                            </div>
                          </div>
                        </Col>{" "}
                        {/* Contact */}
                        <Col md="3" sm="3" xxl="2">
                          <Label htmlFor="mobile" className="form-label">
                            {"Mobile"}
                            <Required />
                          </Label>
                          <div className="form-control-wrap">
                            <input
                              placeholder={"Enter mobile number"}
                              type="text"
                              id="mobile"
                              {...register("mobile_no", {
                                required: "Mobile number is required",
                                validate: {
                                  isValid: (value) =>
                                    /^[6-9]\d{9}$/.test(value) ||
                                    "Enter a valid 10-digit Indian mobile number starting with 6-9",
                                },
                              })}
                              className="form-control"
                              value={watch("mobile_no")}
                              onChange={(e) => {
                                e.target.value = e.target.value.replace(/[^0-9]/g, "");
                                setValue("mobile_no", e.target.value);
                                trigger("mobile_no");
                              }}
                              onInput={(e) => {
                                e.target.value = e.target.value.replace(/[^0-9]/g, "");
                                e.target.value = e.target.value.replace(/[^0-9]/g, "").slice(0, 10);
                              }}
                            />
                            {errors.mobile_no && <span className="invalid">{errors?.mobile_no?.message}</span>}
                          </div>
                        </Col>
                        <ImageUpload
                          watch={watch}
                          label={"Upload Signature"}
                          errors={errors}
                          register={register}
                          image={"sign"}
                          image_url={"sign_url"}
                          handleImageChange={handleImageChange}
                          setValue={setValue}
                          handleImageOpenPreview={handleImageOpenPreview}
                        />
                         <ImageUpload
                          watch={watch}
                          label={"Upload Principal Signature"}
                          errors={errors}
                          register={register}
                          image={"p_sign"}
                          image_url={"p_sign_url"}
                          handleImageChange={handleImageChange}
                          setValue={setValue}
                          handleImageOpenPreview={handleImageOpenPreview}
                        />
                        {/* Status */}
                        <Col md="2" sm="3" xxl="2">
                          <Status
                            setValue={setValue}
                            trigger={trigger}
                            register={register}
                            watch={watch}
                            errors={errors}
                          />
                        </Col>
                      </Row>
                      <Col md="2" className={``}>
                        <MyButton isLoading={isLoading} mode={mode} />
                      </Col>
                    </Form>
                  </PreviewAltCard>
                )}
                {/* <MyDataTable data={data} columns={column} title={"Nodal Center List"} isLoading={loading} /> */}

                <ApiPaginationDataTable
                  columns={column}
                  data={data}
                  isLoading={loading}
                  register={register}
                  trigger={trigger}
                  watch={watch}
                  setValue={setValue}
                  title={"Center List"}
                  errors={errors}
                  serverSearch
                  handleSubmit={handleSubmit}
                  handleSearch={handleSearch}
                  serverSideSearch={serverSideSearch}
                  handlePerRowsChange={handlePerRowsChange}
                  handlePageChange={handlePageChange}
                  totalRows={totalRows}
                  perPage={perPage}
                />
              </Row>
            </Block>
          </>
        )}
      </Content>
      {/* Confirmation Modal */}
      <ConfirmModal
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
        onConfirm={confirmStatusChange}
        status={selectedRow?.status}
      />

      <ViewImage url={watch("image_preview")} imageOpen={imageOpen} handleImageClose={handleImageClose} />
    </>
  );
};

export default NodalCenter;
